const GTM_ID = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID || ''

export const gtmConfig = {
	gtmId: GTM_ID,
	enabled: !!GTM_ID,
}
